import { render, staticRenderFns } from "./AdminColorsNewScreen.vue?vue&type=template&id=32bb7711&scoped=true&"
import script from "./AdminColorsNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminColorsNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb7711",
  null
  
)

export default component.exports